import { Route, RouteObject } from "react-router-dom";
import ComplaintLandingPage from "./components/landing/landing";
import ComplaintRequestDetailPage from "./components/details/details";
import { CreateComplaintRequest } from "./components/create/create";
import ComplaintSuccessPage from "./components/receipt/receipt";
// import { CreateComplaintRequest } from './components';

export interface complaintRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: complaintRoute[];
}

export const complaintRoutes: complaintRoute[] = [
  {
    path: "cx/complaints",
    element: <ComplaintLandingPage />,
  },
  {
    path: "cx/complaints/create",
    element: <CreateComplaintRequest />,
  },
  {
    path: "cx/complaints/create/:step",
    element: <CreateComplaintRequest />,
  },
  {
    path: "cx/complaints/history/:id",
    element: <ComplaintRequestDetailPage />,
  },
  {
    path: "cx/complaints/current/:id",
    element: <ComplaintRequestDetailPage />,
  },
  {
    path: "cx/complaints/success",
    element: <ComplaintSuccessPage />,
  },
];
